import request from '@orq/superagent'
import React from 'react'
import PT from 'prop-types'

class RequestProvider extends React.Component<
  { children: React.ReactNode },
  void
> {
  getChildContext() {
    return { request }
  }

  render() {
    return this.props.children
  }
}

// @ts-expect-error@2339
RequestProvider.childContextTypes = {
  request: PT.func,
}

export default RequestProvider
